import { KnBrCommonService } from "./../services/kn-br-common.service";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { UntypedFormBuilder, ReactiveFormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";

import { AuthService, GlobalMessageService, WindowRef, GlobalMessageType, CmsService, TranslatePipe } from "@spartacus/core";
import {
  LoginFormComponent,
  LoginFormComponentService,
} from "@spartacus/user/account/components";
import { distinctUntilChanged, Observable, take } from "rxjs";
import { environment } from "src/environments/environment";
import { MediaComponent, FormErrorsComponent } from "@spartacus/storefront";
import { AsyncPipe } from "@angular/common";
import { Auth0Service } from "../services/knbr-new-auth0.service";

@Component({
    selector: "kn-br-login-form",
    templateUrl: "./kn-br-login-form.component.html",
    styleUrls: ["./kn-br-login-form.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MediaComponent,
        ReactiveFormsModule,
        FormErrorsComponent,
        RouterLink,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class KnBrLoginFormComponent extends LoginFormComponent {
  errorMessage: string =
    "The credentials you entered are invalid. Please check your username and password and try again.";
  loginInProgress = false;
  baseURL = environment.BASEURL;
  bannerData$: Observable<any>;
  shouldShowLoginScreen=false;

  @ViewChild("copyrightPlaceholder", { read: ElementRef })
  copyrightPlaceholder!: ElementRef;
  constructor(
    protected auth: AuthService,
    protected globalMessageService: GlobalMessageService,
    protected fb: UntypedFormBuilder,
    protected winRef: WindowRef,
    protected loginFormComponentService: LoginFormComponentService,
    protected knBrCommonService: KnBrCommonService,
    private cmsService: CmsService,
    private changeDetectorRef: ChangeDetectorRef,
    protected router: Router,
    protected newAuthService: Auth0Service
  ) {
    super(loginFormComponentService);
    const isInIframe = window.self !== window.top;
    this.bannerData$ = this.cmsService.getComponentData(
      "CwtLoginBackgroundComponent"
    );


    // // *********************************
    // // NEVER COMMENT THIS CODE
    // if (this.baseURL.includes('d1') ) {
    //   // window.open(environment.SSODEV, "_self");
    // } else if(this.baseURL.includes('s1')) {
    //   // window.open(environment.SSOQA, "_self");
    // } else if(this.baseURL.includes('p1') && !isInIframe) {
    //   // window.open(environment.SSOPROD, "_self");
    // }
    // // *********************************
  }
  ngOnInit(): void {
    // super.ngOnInit();
              this.knBrCommonService.getAuth0EnabledStatus().pipe(take(1)).subscribe((responseData:any) => {
            const flagValue = responseData[0];
            // comment this below line for spartacus login
            this.redirectToAuth0PortalBasedOnTheFlag(flagValue) 
      })
    if (this.winRef) {
      this.winRef.document
        .querySelector("kn-br-login-form")
        .classList.add("knbr-user-form");
    }
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      const leftSlot = document.querySelector(".LeftContentSlot");
      const paragraph = leftSlot?.querySelector("cx-paragraph");

      if (paragraph && this.copyrightPlaceholder?.nativeElement) {
        this.copyrightPlaceholder.nativeElement.appendChild(paragraph);
      }
    }, 100);
  }

  redirectToAuth0PortalBasedOnTheFlag(auth0FlagValue) {
    if(auth0FlagValue === 'true') {
      this.redirectToNewAuth0SSO();
    } else {
      this.redirectToSSO();
    }
  }

  checkIsValidUser() {
    if (this.form.valid) {
      this.loginInProgress = true;
      this.knBrCommonService.showSpinner$.next(true);

      const { userId } = this.form.controls;

      this.knBrCommonService.checkIsValidUser(userId.value).subscribe(
        (response: any) => {
          if (response?.response === "Authorized") {
            // loader will remove on KNBR-outletComponent loggedInSubscription
            // this.loginFormComponentService.login();
            this.onSubmit();
            this.loginFormComponentService.isUpdating$
              .pipe(distinctUntilChanged())
              .subscribe((res) => {});
          } else {
            this.globalMessageService.add(
              response,
              GlobalMessageType.MSG_TYPE_ERROR
            );
          }
          this.loginInProgress = false;
          this.changeDetectorRef.detectChanges();
        },
        (error) => {
          this.knBrCommonService.showSpinner$.next(false);
          const errorResponse = error.error;
          if (
            errorResponse &&
            errorResponse.errors &&
            errorResponse.errors.length > 0
          ) {
            // this.globalMessageService.add(errorResponse.errors[0].message, GlobalMessageType.MSG_TYPE_ERROR);
            this.globalMessageService.add(
              this.errorMessage,
              GlobalMessageType.MSG_TYPE_ERROR
            );
            this.knBrCommonService.showSpinner$.next(false);
          }
          this.loginInProgress = false;
          this.knBrCommonService.showSpinner$.next(false);
          this.changeDetectorRef.detectChanges();
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }
  redirectToSSO() {
    window.open(environment.SSODEV, "_self");
  }

    async redirectToNewAuth0SSO() {
    const newUrl = await this.newAuthService.getAuthorizeUrl();
    window.open(newUrl, '_self');
  }
}
